import { render, staticRenderFns } from "./ModalSubcliente.vue?vue&type=template&id=0813f03c"
import script from "./ModalSubcliente.vue?vue&type=script&lang=js"
export * from "./ModalSubcliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports